<template>
<header class="header sticky-top d-print-none">
    <nav class="navbar navbar-light navbar-expand-lg">
        <div class="w-100">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-4 col-md-5 d-lg-none d-flex align-items-center justify-content-sm-start">
                        <button class="navbar-toggler"
                                type="button"
                                @click="toggleMobileMenu">
                            <span class="navbar-toggler-icon"></span>
                        </button>
                    </div>
                    <div class="col-4 col-md-2 col-lg-2 d-flex align-items-center justify-content-center logo">
                        <RouterLink to="/"
                                    class="navbar-brand d-block mt-1 mb-1">
                            <div class="d-inline-block header__logo align-top"
                                 alt="ЭМК"
                                 loading="ЭМК"
                                 title="Энергомашкомплект"></div>
                        </RouterLink>
                    </div>

                    <div class="order-3 order-lg-2 d-flex col-lg-8 align-items-center justify-content-center nav-menu">
                        <div class="navbar-collapse"
                             :class="{ 'collapse': !isMobileMenuOpen }">
                            <!-- 1 уровень -->
                            <ul class="navbar-nav m-auto">
                                <li class="nav-item dropdown"
                                    @mouseenter="isMobileScreen ? '' : openDropdown(point.id)"
                                    @mouseleave="isMobileScreen ? '' : leaveDropdown()"
                                    @click="isMobileScreen ? handleDropdown(activeDrop == point.id ? 'close' : 'open', point.id) : ''"
                                    :class="[{ 'dropdown--opened': point.id == activeDrop },
                                    { 'dropdown--mobile': isMobileScreen }]"
                                    v-for="point in visibleMainMenuPoints"
                                    :key="'point' + point.id">
                                    <div class="nav-link nav-link--main-points dropdown-toggle"
                                         :to="{ name: point.href }"
                                         @click="isMobileScreen ? '' : handleDropdown('open', point.id)">
                                        {{ point.name }}
                                    </div>
                                    <!-- 2 уровень -->
                                    <ul class="dropdown-menu dropdown dropdown--opened">
                                        <div v-for="subpoint in point.subPoints"
                                             :key="'subpoint' + point.name + subpoint.id">
                                            <!-- id письма -->
                                            <li v-if="subpoint.id == 2.8"
                                                class="dropdown__item"
                                                @mouseenter="openSidepoints(subpoint)"
                                                @mouseleave="isMobileScreen ? '' : leaveSidepoints()"
                                                @click.stop="handleDropdown('close', point.id)">
                                                <a :href=subpoint.href
                                                   download>
                                                    {{ subpoint.name }}</a>
                                            </li>
                                            <li v-else
                                                class="dropdown__item dropdown "
                                                :class="[{ 'dropdown__item--active': currentRoute == subpoint.href },
                                                { 'dropdown--opened': activeSidepoints == subpoint.id }]"
                                                @mouseenter="openSidepoints(subpoint)"
                                                @mouseleave="isMobileScreen ? '' : leaveSidepoints()"
                                                @click.stop="subpoint.subpoints?.length ? openSidepoints(subpoint, true) : handleDropDownItemClick(subpoint)">
                                                {{ subpoint.name }}
                                                <!-- Третий уровень -->
                                                <ul v-if="'subpoints' in subpoint && subpoint.subpoints?.length"
                                                    class="dropdown__item--side dropdown-menu">
                                                    <div v-for="point in subpoint.subpoints"
                                                         :key="'subpoint' + point.name + subpoint.id">
                                                        <li class="dropdown__item"
                                                            :class="{ 'dropdown__item--active': currentRoute == point.href }"
                                                            @click.stop="handleDropDownItemClick(point)">
                                                            {{ point.name }}
                                                        </li>
                                                    </div>
                                                </ul>
                                            </li>
                                        </div>
                                    </ul>
                                </li>
                                <div class="navbar-nav__icon__wrapper">
                                    <div>
                                        <SearchIcon class="navbar-nav__search-icon"
                                                    @click="visibleSearchModal = true" />
                                    </div>
                                    <SearchModal :visibleModal=visibleSearchModal
                                                 @closeSearchModal="visibleSearchModal = false" />
                                    <LayoutHeaderModeChanger />
                                </div>
                            </ul>
                        </div>
                    </div>

                    <div
                         class="order-2 order-lg-3 col-4 col-md-5 col-lg-2 mt-3 mb-4 mt-md-0 mb-md-0 d-flex align-items-center justify-content-end header__right-top">
                        <LayoutHeaderNotifications />
                        <div class="header__user"
                             v-if="userFio"
                             @click="visibleSidebar = true">
                            <div v-if="featureFlags.pointsSystem"
                                 class="header__points-balance__wrapper">
                                <div class="header__points-balance"
                                     title="Ваши баллы"
                                     @click.stop.prevent="pointsModalIsOpen = true">
                                    {{ userScore }}
                                </div>
                            </div>
                            <div class="header__user__block">
                                <img class="header__user__block__img"
                                     :src="userAvatar"
                                     alt="Ваша фотография" />
                                <div class="header__user__block__title d-none d-lg-flex">
                                    <span class="header__user__block__name">
                                        {{ userFio }}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div @click="visibleSidebar = true"
                             v-else>
                            ...
                        </div>
                        <SlotModal v-if="pointsModalIsOpen == true && featureFlags.pointsSystem"
                                   @close="pointsModalIsOpen = false">
                            <LayoutHeaderPointsModal />
                        </SlotModal>
                    </div>
                </div>
            </div>
        </div>
    </nav>
</header>
<SidebarLk @closeSidebar="visibleSidebar = false"
           :visibleSidebar="visibleSidebar" />
</template>

<script lang="ts">
import { ref, computed, watch, defineComponent } from "vue";
import { mainMenuPoints } from "@/assets/static/navLinks";
import type { IMenuPoint, ISubPoint } from "@/interfaces/ILayout";
import { usePageDataStore } from "@/stores/pageData";
import { useRoute, useRouter } from "vue-router";
import SidebarLk from "../sidebars/TopRightSidebar.vue";
import SearchIcon from "@/assets/icons/layout/SearchIcon.svg?component";
import SearchModal from "@/components/tools/modal/SearchModal/SearchModal.vue";
import { useUserData } from "@/stores/userData";
import { useTimeoutFn, useWindowSize } from '@vueuse/core'
import { screenCheck } from "@/utils/screenCheck";
import { useUserScore } from "@/stores/userScoreData";
import SlotModal from "@/components/tools/modal/SlotModal.vue";
import LayoutHeaderPointsModal from "./LayoutHeaderPointsModal.vue";

import { featureFlags } from "@/assets/static/featureFlags";
import LayoutHeaderModeChanger from "./LayoutHeaderModeChanger.vue";
import LayoutHeaderNotifications from "./LayoutHeaderNotifications.vue";

export default defineComponent({
    components: {
        SidebarLk,
        SearchIcon,
        SearchModal,
        SlotModal,
        LayoutHeaderPointsModal,
        LayoutHeaderModeChanger,
        LayoutHeaderNotifications
    },
    setup() {
        const userData = useUserData();
        const pageDataStore = usePageDataStore();
        const route = useRoute();
        const visibleSidebar = ref(false);
        const isMobileMenuOpen = ref(false);
        const visibleSearchModal = ref(false);
        const router = useRouter();
        const activeDrop = ref<null | number>(null);
        const activeSidepoints = ref<number | null>(null);
        const { width } = useWindowSize();
        const isMobileScreen = computed(() => ['sm', 'md'].includes(screenCheck(width)));
        const pointsModalIsOpen = ref(false);
        const { start: scheduleDropdownOpen, stop: cancelDropdownOpen } = useTimeoutFn(
            (id: number) => handleDropdown('open', id), 250, { immediate: false }
        );
        const { start: scheduleSidepointsOpen, stop: cancelSidepointsOpen } = useTimeoutFn(
            (id: number | null) => activeSidepoints.value = id, 250, { immediate: false }
        );
        const { start: scheduleDropdownClose, stop: cancelDropdownClose } = useTimeoutFn(
            () => closeDropdown(), 300, { immediate: false }
        );
        const { start: scheduleSidepointsClose, stop: cancelSidepointsClose } = useTimeoutFn(
            () => {
                cancelSidepointsOpen();
                activeSidepoints.value = null;
            }, 300, { immediate: false }
        );

        const closeDropdown = () => {
            cancelDropdownClose();
            cancelSidepointsClose();
            cancelDropdownOpen();
            cancelSidepointsOpen();
            activeDrop.value = null;
            activeSidepoints.value = null;
        };

        const openDropdown = (id: number) => {
            cancelDropdownClose();
            cancelSidepointsClose();
            cancelDropdownOpen();
            cancelSidepointsOpen();
            if (activeDrop.value === null || activeDrop.value === id) return handleDropdown('open', id);
            scheduleDropdownOpen(id);
        };

        const leaveDropdown = () => {
            cancelDropdownOpen();
            cancelSidepointsOpen();
            scheduleDropdownClose();
        };

        const openSidepoints = (point: ISubPoint, immediate = false) => {
            cancelSidepointsClose();
            cancelSidepointsOpen();
            const id = point.subpoints?.length ? point.id : null;
            if (immediate || isMobileScreen.value || activeSidepoints.value === null || activeSidepoints.value === id) {
                activeSidepoints.value = id;
                return;
            }
            scheduleSidepointsOpen(id);
        };

        const leaveSidepoints = () => {
            cancelSidepointsOpen();
            scheduleSidepointsClose();
        };

        const hasVisibilityAccess = (point: { visibility?: number }) => {
            return point.visibility === undefined
                || (userData.getUserRoots.VisionRoots ?? []).includes(point.visibility);
        };

        const filterVisibleSubPoints = (points: ISubPoint[]): ISubPoint[] => {
            return points
                .filter(hasVisibilityAccess)
                .map((point) => ({
                    ...point,
                    ...(point.subpoints
                        ? { subpoints: filterVisibleSubPoints(point.subpoints) }
                        : {}),
                }));
        };

        const visibleMainMenuPoints = computed<IMenuPoint[]>(() => {
            return mainMenuPoints
                .filter(hasVisibilityAccess)
                .map((point) => ({
                    ...point,
                    subPoints: filterVisibleSubPoints(point.subPoints),
                }));
        });

        watch(
            () => route.name,
            (newVal) => {
                if (newVal) {
                    closeDropdown();
                    pageDataStore.setCurrentRoute(String(newVal));
                }
            }
        )

        const handleDropdown = (type: 'open' | 'close', id: number) => {
            if (type === 'close') return closeDropdown();

            cancelDropdownClose();
            cancelSidepointsClose();
            cancelDropdownOpen();
            cancelSidepointsOpen();
            if (activeDrop.value !== id) activeSidepoints.value = null;
            activeDrop.value = id;
        };

        const handleDropDownItemClick = (point: ISubPoint) => {
            closeDropdown();

            if (!point.href) return;

            if (/^https?:\/\//i.test(point.href)) {
                isMobileMenuOpen.value = false;
                const url = new URL(point.href);

                if (point.includeSessionId) {
                    url.searchParams.set('session_id', userData.getAuthKey);
                }

                globalThis.location.href = url.toString();
                return;
            }

            router.push({
                name: point.href,
            })
                .then(() => isMobileMenuOpen.value = false);
        };

        return {
            visibleMainMenuPoints,
            activeDrop,
            visibleSidebar,
            visibleSearchModal,
            isMobileMenuOpen,
            pointsModalIsOpen,
            userScore: computed(() => useUserScore().getCurrentScore),
            userAvatar: computed(() => userData.getPhoto),
            userFio: computed(() => userData.getFio),
            currentRoute: computed(() => pageDataStore.getCurrentRoute),
            isMobileScreen,
            featureFlags,
            activeSidepoints,
            openDropdown,
            openSidepoints,
            leaveDropdown,
            leaveSidepoints,
            handleDropdown,
            handleDropDownItemClick,
            toggleMobileMenu: () => isMobileMenuOpen.value = !isMobileMenuOpen.value,
        };
    },
});
</script>
